(() => {
  'use strict';

  const root = document.documentElement;
  const media = matchMedia('(max-width: 899px)');
  const hiddenClass = 'bp-wa-cta-obscured';
  const selectors = [
    '.bp-cart-page-summary .cart__checkout[name="checkout"]',
    '#CartDrawer.wt-cart__drawer--open .wt-cart__cta[name="checkout"]',
    'form[data-type="add-to-cart-form"] [name="add"][type="submit"]',
    'sticky-buy-button.wt-product__sticky-buy--show .wt-product__sticky-buy__button',
    '.bp-pdp .buyrow .cta',
    '.bp-pdp .dock.on .cta',
    '.bp-pdp #shCheckout',
    '.bp-pannello .buyrow .cta',
    '.bp-pannello .dock.on .cta',
    '.bp-pannello #shCheckout',
    '.bv-pdp .bar .cta',
    '.bv-panel .bar .cta',
    '.bp-bvs-ref__sticky.is-visible [data-sticky-cta]',
    '.bp-tinta-ref__sticky.is-visible [data-sticky-cta]'
  ].join(',');
  let widget = null;
  let originalInert = false;
  let hidden = false;
  let frame = 0;
  let discovery = null;
  let widgetParentObserver = null;
  const watched = new WeakSet();

  const visibleRect = (element, rect) => {
    if (!rect.width || !rect.height || rect.right <= 0 || rect.bottom <= 0 ||
        rect.left >= innerWidth || rect.top >= innerHeight) return false;
    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };
  const intersects = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 &&
    a.top < b.bottom + 8 && a.bottom > b.top - 8;

  const restore = () => {
    root.classList.remove(hiddenClass);
    if (hidden && widget) widget.inert = originalInert;
    hidden = false;
  };
  const hide = (target) => {
    if (hidden) return;
    if (widget?.contains(document.activeElement)) {
      const focusTarget = target?.matches(':disabled') ? null : target;
      focusTarget?.focus({preventScroll: true});
    }
    originalInert = widget.inert;
    widget.inert = true;
    root.classList.add(hiddenClass);
    hidden = true;
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(() => {
      frame = 0;
      measure();
    });
  };
  const discover = () => {
    if (discovery || widget || !document.body || typeof MutationObserver !== 'function') return;
    discovery = new MutationObserver(schedule);
    discovery.observe(document.body, {childList: true, subtree: true});
  };
  const attach = () => {
    const next = document.getElementById('wa-chat-btn-root');
    if (next === widget) return;
    restore();
    widgetParentObserver?.disconnect();
    widgetParentObserver = null;
    widget = next;
    originalInert = widget?.inert ?? false;
    if (widget) {
      discovery?.disconnect();
      discovery = null;
      resizeObserver?.observe(widget);
      if (typeof MutationObserver === 'function' && widget.parentElement) {
        widgetParentObserver = new MutationObserver(schedule);
        widgetParentObserver.observe(widget.parentElement, {childList: true});
      }
    } else discover();
  };

  const stateObserver = typeof MutationObserver === 'function' ? new MutationObserver(schedule) : null;
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const watch = (element) => {
    if (!element || watched.has(element)) return;
    watched.add(element);
    stateObserver?.observe(element, {attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'open']});
    resizeObserver?.observe(element);
  };
  const measure = () => {
    attach();
    if (!widget || !media.matches) { restore(); return; }
    if (document.body.classList.contains('page-overlay-cart-on')) {
      hide(document.querySelector('#CartDrawer .wt-cart__cta[name="checkout"]'));
      return;
    }
    const widgetRect = widget.getBoundingClientRect();
    const widgetStyle = getComputedStyle(widget);
    if (!widgetRect.width || !widgetRect.height || widgetStyle.display === 'none' ||
        (widgetStyle.visibility === 'hidden' && !hidden)) { restore(); return; }

    const targets = document.querySelectorAll(selectors);
    let collision = null;
    for (const target of targets) {
      watch(target);
      watch(target.parentElement);
      watch(target.closest('.bp-pdp, .bp-pannello, .bv-pdp, .bv-panel, sticky-buy-button, .dock, .bar, .bp-bvs-ref__sticky, .bp-tinta-ref__sticky'));
      const rect = target.getBoundingClientRect();
      if (visibleRect(target, rect) && intersects(widgetRect, rect)) {
        collision = target;
        break;
      }
    }
    if (collision) hide(collision);
    else restore();
  };

  const start = () => {
    if (typeof MutationObserver === 'function') {
      const bodyObserver = new MutationObserver(schedule);
      bodyObserver.observe(document.body, {attributes: true, attributeFilter: ['class'], childList: true});
    }
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
    document.addEventListener('click', schedule, {capture: true});
    document.addEventListener('change', schedule, {capture: true});
    document.addEventListener('transitionend', event => {
      if (event.target.closest?.(selectors)) schedule();
    }, {capture: true});
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart-drawer:refresh', schedule);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    document.addEventListener('visibilitychange', schedule);
    media.addEventListener?.('change', schedule);
    document.fonts?.ready?.then(schedule).catch(() => {});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
